import React, { useEffect, useState, useReducer, useCallback, useMemo } from 'react';
import axios from 'axios';

import PrimaryButton from '../common/PrimaryButton';
import Table from '../common/Table';
import SearchUser from '../common/SearchUser';
import filterReducer from '../../reducers/filter.reducer';
import FilterDispatch from '../../contexts/filterDispatch';

import style from './ManageUsersPage.module.css';

const ManageUsersPage = React.memo(({ history }) => {
  const params = useMemo(() => new URLSearchParams(history.location.search), [history.location.search]);
  
  const [tableUsers, setTableUsers] = useState([]);
  const [userState, setUserState] = useState({
    isEditUser: false,
    isNewUser: false,
    user: null,
    securityLevels: [],
    userId: null,
    hubs: [],
  });

  const addUserAction = e => {
    e.preventDefault();

    history.push({
      pathname: '/users/add',
      state: {
        ...userState,
        isNewUser: true,
      },
    });
  };

  const editUserAction = (e, user) => {
    e.preventDefault();

    history.push({
      pathname: `agencies/${user.AgencyId}/users/${user.Id}`,
      state: {
        ...userState,
        isEditUser: true,
        user,
      },
    });
  };

  const renderActionButtons = props => {
    const { original } = props;

    if (original) {
      return (
        <div className={style.columnAlign}>
          <button
            type="button"
            className={`${style.btn} ${style.btnEdit}`}
            onClick={e => editUserAction(e, original)}
          >
            Edit
          </button>
        </div>
      );
    }

    return null;
  };

  const retrieveUsers = useCallback(() => {
    const handleSussessUsersRequest = response => {
      setTableUsers(response.data);
    };
    const handleSussessSecurityLevelsRequest = response => {
      const levels = response.data.map(l => ({
        value: l.Value,
        label: l.Name,
      }));

      setUserState(prevState => ({
        ...prevState,
        securityLevels: levels,
      }));
    };

    const handleSussessHUBsRequest = response => {
      const HUBs = response.data.map(l => ({
        value: l.Value,
        label: l.Name,
      }));

      setUserState(prevState => ({
        ...prevState,
        hubs: HUBs,
      }));
    };

    const handleErrorUsersRequest = () => {};
    const handleErrorSecurityLevelsRequest = () => {};
    const handleErrorHUBsRequest = () => {};

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}manage-users?name=${params.get('q') ||
          ''}`,
      )
      .then(handleSussessUsersRequest)
      .catch(handleErrorUsersRequest);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}listitems/securitylevels`)
      .then(handleSussessSecurityLevelsRequest)
      .catch(handleErrorSecurityLevelsRequest);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}hubs`)
      .then(handleSussessHUBsRequest)
      .catch(handleErrorHUBsRequest);
  }, [params]);

  useEffect(() => {
    retrieveUsers();

    document.title = 'HUB Portal: Manage Users';
  }, [retrieveUsers]);

  const columnSet = [
    {
      id: 'Id',
      accessor: props => {
        return props.Id;
      },
      show: false,
    },
    {
      accessor: 'FirstName',
      Header: 'First Name',
      width: 140,
    },
    {
      accessor: 'LastName',
      Header: 'Last Name',
      width: 140,
    },
    {
      accessor: 'Email',
      Header: 'Email',
      width: 300,
    },
    {
      accessor: 'SecurityLevel',
      Header: 'Security Level',
      width: 140,
    },
    {
      accessor: 'AgencyName',
      Header: 'HUB',
      width: 350,
    },
    {
      accessor: 'Locked',
      Header: 'Acct Locked',
      width: 140,
    },
    {
      accessor: 'IsLocked',
      show: false,
    },
    {
      accessor: 'actions',
      Header: '',
      sortable: false,
      Cell: props => renderActionButtons(props),
      className: '',
      minWidth: 150,
    },
  ];

  const [state, dispatch] = useReducer(filterReducer, {
    filterChanged: false,
  });

  const { filterChanged } = state;

  useEffect(() => {
    if (filterChanged) {
      retrieveUsers();
    }
  }, [filterChanged, retrieveUsers]);

  return (
    <FilterDispatch.Provider value={dispatch}>
      <div className={style.manageUsers}>
        <div className={style.header}>
          <h1>Manage Users</h1>
          <PrimaryButton
            text="Add New User"
            type="button"
            onClick={addUserAction}
            styles={{
              width: '140px',
              margin: 0,
              height: '43px',
              lineHheight: '40px',
              fontSize: '15px',
              letterSpacing: '-.2px',
              boxSizing: 'content-box',
              marginBottom: '25px',
            }}
          />
        </div>
        <SearchUser history={history} />
        <Table
          data={tableUsers}
          columns={columnSet}
          pageSizeOptions={[10, 25, 50, 100]}
          entityNameText="users"
        />
      </div>
    </FilterDispatch.Provider>
  );
});

ManageUsersPage.propTypes = {};

export default ManageUsersPage;
